import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmex = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 63,
	height: 40,
	viewBox: "0 0 63 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.5 7.16418C0.5 3.48365 3.48365 0.5 7.16418 0.5H54.9254C58.6059 0.5 61.5896 3.48365 61.5896 7.16418V32.8358C61.5896 36.5163 58.6059 39.5 54.9254 39.5H7.16418C3.48366 39.5 0.5 36.5163 0.5 32.8358V7.16418Z",
		fill: "#006FCF",
		stroke: "#D6DCE5"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M62.1123 7.2421H56.9731L54.2868 14.9509L51.4836 7.2421H46.2277V19.2453L40.8549 7.2421H36.5335L31.1607 19.5059H34.8981L35.9493 17.0533H41.5558L42.6069 19.5059H49.6149V10.9795L52.7684 19.5059H55.6883L58.8418 10.9795V19.5059H62.1123V21.3746H57.7906L54.2868 25.2291L50.666 21.3746H35.8326V33.6384H50.5494L54.1698 29.6674L57.7906 33.6384H62.1123V35.1565H56.9731L54.1698 32.12L51.3666 35.1565H33.9639V21.141H28.3574L35.3654 5.37305H42.1397L44.5923 10.7459V5.37305H53.002L54.4035 9.4611L55.8053 5.37305H62.1123V7.2421ZM62.1123 24.0609L58.9588 27.448L62.1123 30.8352V33.6384L56.3892 27.448L62.1123 21.3746V24.0609ZM46.2277 33.6384V30.7186H39.2198V28.8498H46.1107V26.0466H39.2198V24.1779H46.2277V21.3746L52.0675 27.448L46.2277 33.6384ZM37.0004 14.3667L38.6359 10.3956L40.271 14.3667H37.0004Z",
		fill: "white"
	})]
});
export default SvgAmex;
